import { Type } from 'typebox';
import { StoryWithPages } from '@tadpoles/common';
export const StoriesPayload = Type.Object({
    timestamp: Type.Integer(),
    stories: Type.Array(StoryWithPages),
    cursor: Type.Optional(Type.String())
});
export class HttpStoriesResource {
    #httpClient;
    constructor(httpClient) {
        this.#httpClient = httpClient;
    }
    async list(request = {}, options) {
        const queryParams = {
            paging: 'true'
        };
        if (typeof request.timestamp !== 'undefined') {
            if (!Number.isSafeInteger(request.timestamp)) {
                throw new Error('Story timestamps must be safe integers');
            }
            queryParams['timestamp'] = String(request.timestamp);
        }
        if (typeof request.cursor !== 'undefined') {
            queryParams['cursor'] = request.cursor;
        }
        const payload = await this.#httpClient.get({
            path: '/library/stories',
            queryParams,
            payloadSchema: StoriesPayload,
            signal: options?.signal
        });
        return {
            ...payload,
            stories: payload.stories.map((story) => ({
                ...story,
                pages: [...story.pages].sort((first, second) => first.ordinal - second.ordinal)
            }))
        };
    }
}
